import { User } from 'app/actions/customer';

export const getDriverName = (driver: User | any) =>
	`${driver?.lastName || '---'} ${driver?.firstName || '---'} ${driver?.middleName || '----'}`;
export const getDriverInfo = (driver: User | any) => `${driver?.phone || '---'} ${driver?.companyName || '---'}`;
